import { sleep } from "./async";

/**
 * Download a remote file to the system
 *
 * @param url Data URI or URL
 * @param name File name
 */
export function download(url: string, name: string) {
	const xhr = new XMLHttpRequest();
	xhr.responseType = "blob";
	xhr.onload = () => downloadBlob(xhr.response, name);
	xhr.open("GET", url);
	xhr.send();
}

/**
 * Download a local blob to the system
 *
 * @param blob Data blob
 * @param name File name
 */
export function downloadBlob(blob: Blob, name: string) {
	const link = document.createElement("a");
	const url = URL.createObjectURL(blob);

	link.download = name;
	link.href = url.toString();

	document.body.appendChild(link);

	link.click();

	sleep(1000).then(() => {
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url);
	});
}
